export default __webpack_public_path__ + "static/1278-65d64188e669769111824455dc75d7bf.gif";